<div class="min-h-screen bg-[#FFF7CC] pt-32">
      <div class="max-w-7xl mx-auto px-4 py-20 text-center">
        <div class="bg-white rounded-2xl border-2 border-yellow-200 p-12 shadow-lg">
          <div class="w-20 h-20 bg-[#1F1C1A] rounded-full flex items-center justify-center mx-auto mb-6">
            <svg class="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
            </svg>
          </div>
          <h1 class="text-4xl md:text-5xl font-bold text-[#1F1C1A] mb-6">
            {{ pageTitle }}
          </h1>
          <p class="text-xl text-gray-700 mb-8 max-w-2xl mx-auto">
            This page is coming soon! We're working on creating amazing content for this section. 
            Please check back later or continue exploring our other pages.
          </p>
          <div class="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              class="px-8 py-4 bg-[#1F1C1A] text-white rounded-full font-semibold hover:bg-gray-800 transition-colors duration-200"
              (click)="goHome()"
            >
              Go to Homepage
            </button>
            <button 
              class="px-8 py-4 border-2 border-[#1F1C1A] text-[#1F1C1A] rounded-full font-semibold hover:bg-[#1F1C1A] hover:text-white transition-all duration-200"
              (click)="contactUs()"
            >
              Contact Us
            </button>
          </div>
          <div class="mt-12 p-6 bg-[#FFF7CC] rounded-xl border border-yellow-300">
            <p class="text-gray-600">
              <strong>Want to help us prioritize this page?</strong><br>
              Let us know what content would be most valuable to you by reaching out to our team.
            </p>
          </div>
        </div>
      </div>
    </div>